<script lang="ts">
  /** 入出力例（problem-format.md §2.4、§7）。sampleCases の結果を「入力例 1 / 出力例 1」で並べる */
  import type { ProblemCase } from './types';

  interface Props {
    cases: readonly ProblemCase[];
  }

  let { cases }: Props = $props();

  const trim = (s: string) => s.replace(/\n$/, '');
</script>

<div class="samples" data-testid="sample-cases">
  {#each cases as c, i (i)}
    <div class="pair" data-testid="sample-case">
      <div>
        <h4 class="sub">入力例 {i + 1}</h4>
        <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
        <pre class="output" tabindex="0" aria-label="入力例 {i + 1}">{trim(c.in) ||
            '（なし）'}</pre>
      </div>
      <div>
        <h4 class="sub">出力例 {i + 1}</h4>
        <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
        <pre class="output" tabindex="0" aria-label="出力例 {i + 1}">{trim(c.out)}</pre>
      </div>
    </div>
  {/each}
</div>

<style>
  .samples {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  .pair {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
    gap: var(--space-3);
  }
  .sub {
    font-size: var(--fs-sm);
    color: var(--text-soft);
    font-weight: var(--fw-semibold);
    margin-bottom: var(--space-1);
  }
</style>
